import yup, { ValidationError } from 'yup'


import { AddressInfoFieldsNames } from '../../formDefinitions/AddressInfoForm/AddressInfoFields'
import { CorrespondenceAddressInfoFieldsNames } from '../../formDefinitions/AddressInfoForm/CorrespondenceAddressInfoFields'
import { BasicInfoFieldsNames } from '../../formDefinitions/BasicInfo/BasicInfoFields'
import { ExtendedInfoFieldsNames } from '../../formDefinitions/ExtendedInfo/ExtendedInfoFields'
import { AdditionalIncomeAdditionalFieldsNames, AdditionalIncomeBasicFieldsNames } from '../../formDefinitions/IncomeInfoForm/AdditionalIncomeFields'
import { IncomeAdditionalFieldsNames, IncomeBasicFieldsNames } from '../../formDefinitions/IncomeInfoForm/IncomeInfoFields'
import { IFields } from './IFieldsDefinition'

// Enum zawierający nazwy wszystkich obiektów BAZOWEGO FORMULARZA 
export enum FormNames {
   BasicInfoForm = "BasicInfoForm",
   ExtendedInfoForm = "ExtendedInfoForm",
   AddressInfoForm = "AddressInfoForm",
   IncomeInfoForm = "IncomeInfoForm",
}

// Enum zawierający nazwy wszystkich obiektów DODATKOWYCH FORMULARZY 
export enum AdditionalFormNames {
   AdditionalIncomeForm = "AdditionalIncomeForm",
   CorrespondenceAddressForm = "CorrespondenceAddressForm",
}

// Wszystkie nazwy pól z podstawowego formularza
export const AllBasedFieldsNames = { ...BasicInfoFieldsNames, ...ExtendedInfoFieldsNames, ...AddressInfoFieldsNames, ...IncomeBasicFieldsNames, ...IncomeAdditionalFieldsNames }
export type TAllBasedFieldsNames = BasicInfoFieldsNames | ExtendedInfoFieldsNames | AddressInfoFieldsNames | IncomeBasicFieldsNames | Partial<IncomeAdditionalFieldsNames>


// Wszystkie nazwy pól z dodatkowych formularzy
export type TAllAdditionalFieldsNames = CorrespondenceAddressInfoFieldsNames | AdditionalIncomeBasicFieldsNames | Partial<AdditionalIncomeAdditionalFieldsNames>
export const AllAdditionalFieldsNames = { ...CorrespondenceAddressInfoFieldsNames, ...AdditionalIncomeBasicFieldsNames, ...AdditionalIncomeAdditionalFieldsNames }



export type TAllFormNames = FormNames | AdditionalFormNames;


// Definicje związane z WALIDACJĄ
export type GenericCustomValidationFunction = (...args: any[]) => boolean | ValidationError;
export type IFieldValidation = yup.StringSchema | yup.ObjectSchema<yup.AnyObject> | GenericCustomValidationFunction;


export type FormValidationObject<T extends Record<string, string>> = {
   [K in keyof T]: IFieldValidation | undefined;
}



// Model obiektu podstawowego formularza
export interface IFormDefinition {
   name: FormNames;
   fields: IFields;
   label?: string;
   urlPath: string;
   previousFormUrlPath?: string ;
   nextFormUrlPath?: string;
   canStepBackInForm: boolean;
   formValidationFunctions: FormValidationObject<Partial<typeof AllBasedFieldsNames>>;
}

// Model obiektu dodatkowego formularza
export interface IAdditionalFormDefinition extends Omit<IFormDefinition, 'urlPath' | 'previousFormUrlPath' | 'nextFormUrlPath' | 'canStepBackInForm' | 'fields' | 'name' | 'formValidationFunctions' > {
   name: AdditionalFormNames;
   additionalFields: IFields;
   switchLabel: string;
   formValidationFunctions: FormValidationObject<Partial<typeof AllAdditionalFieldsNames>>;
}